import React from 'react';
import Config from '~/config';

const MetaTwitter = ({
  url, title, description, image, siteURL, twitterUser,
}) => {
  if (Config.isChina()) return null;
  return (
    <>
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:site" content={siteURL} />
      <meta name="twitter:creator" content={`@${twitterUser}`} />
    </>
  );
};

export default MetaTwitter;
